
<app-header>

</app-header> 


<div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>

<app-footer>

</app-footer>

<!-- Marca de agua "subir a test": se activa con sitioTest en environment -->
<div *ngIf="sitioTest" class="marca-agua-test" aria-hidden="true"></div>
